import Divider from '@material-ui/core/Divider';
import asbvpercentile, { ASBVPercentile, ASBVPercentiles } from 'api/query/asbv';
import { ReactComponent as ASBVskeleton } from 'assets/images/ASBV-loading-skeleton.svg';
import { CloseOutlinedIcon } from 'components/icons/close-outlined';
import { usePrime } from 'pages/search/prime/use-prime';
import React, { useEffect, useState } from 'react';
import ASBVPercentileTable from '../asbv-percentile-table';
import { ASBVsFilterValue } from '../asbvs-filter-value';
import { getDisplayedPercentiles, ShowPercentile } from '../asbvs-utils';
import { useASBVs } from '../use-asbvs';
import { ASBVTooltipProps } from './asbv-tooltip-props';
import './asbv-tooltip.scss';

export const ASBVTooltip: React.FC<ASBVTooltipProps> = ({ asbv }) => {
  const { primeFilters: { db } } = usePrime();
  const { setSelectedTooltip } = useASBVs();
  const [loading, setLoading] = useState(true);
  const [asbvPercentiles, setASBVPercentiles] = useState<ASBVPercentiles>({} as ASBVPercentiles);
  const [percentiles, setPercentiles] = useState<ASBVPercentile[]>([]);

  /**
   * Closes the tooltip.
   */
  const closeTooltip = () => {
    setSelectedTooltip({} as ASBVsFilterValue);
  };

  useEffect(() => {
    if (!ShowPercentile(asbv)) {
      setLoading(false);
      return;
    }

    let cancelled = false;
    async function getPercentiles() {
      setLoading(true);

      if (asbv) {
        const percentileValues = await asbvpercentile.getPercentile(db.id, asbv.columnName);

        if (cancelled) {
          return;
        }

        setASBVPercentiles(percentileValues);
        setPercentiles(getDisplayedPercentiles(percentileValues));
      }

      setLoading(false);
    }
    getPercentiles();

    return () => {
      cancelled = true;
    };
  }, [asbv, db]);

  return (
    <div className={`sg-asbv-tooltip ${loading ? 'sg-asbv-tooltip--loading' : ''}`}>
      {loading
        && (
          <div className="sg-asbv-tooltip__skeleton">
            <ASBVskeleton />
          </div>
        )}
      {!loading && asbvPercentiles && (
        <>
          <h5 className="asbv__title">{`${asbv.label} (${asbv.abbrev})`}</h5>
          <div className="asbv__description">{asbv.description}</div>
          <Divider className="divider" />
          {asbvPercentiles.displayAverage && (
            <div className="industry-average">
              <h6>Industry average value: {asbvPercentiles.average}</h6>
            </div>
          )}
          <div className="how-to-search">{asbv.searchInfo}</div>
          {ShowPercentile(asbv) && (
            <ASBVPercentileTable asbv={asbv} />
          )}

        </>
      )}
      <CloseOutlinedIcon
        className="tooltip-close"
        onClick={() => closeTooltip()}
      />
    </div>
  );
};
